var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BLink',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.process.apply(null, arguments)}}},[_vm._v("PZ ")])
}
var staticRenderFns = []

export { render, staticRenderFns }